import * as IconFile from '../Icon/Icon';
import SanitizedHtml from '../SanitizedHtml/SanitizedHtml';
import { CmsMeta } from '../cms/cmsMeta';
import './CmsMessage.css';

const { Icon, ...icons } = IconFile;

type CmsMessageParams = {
	/** A name from the icon registry, or anything else - an emoji - shown as written. */
	icon?: string;
	type: 'success' | 'warning' | 'error';
	/** Simple html: bold, links and <br> survive the sanitiser, scripts do not. */
	text: string;
};

// own properties only: the rest object above still inherits `constructor` and friends
const isIconName = (icon: string): icon is keyof typeof icons => Object.prototype.hasOwnProperty.call(icons, icon);

export const CmsMessage = ({ icon, type, text }: CmsMessageParams): JSX.Element => (
	<div className={`cms-message ${type}`}>
		{icon && (isIconName(icon) ? <Icon shape={icons[icon]} /> : <span className="emoji">{icon}</span>)}
		<SanitizedHtml as="span" className="text" html={text} />
	</div>
);

export const cmsMeta: CmsMeta = {
	description:
		'A notice in a coloured box: type success is green, warning yellow, error red. The icon is an emoji, or the name of a built-in icon such as info; leave it out for none. The text takes simple html, so <strong> for a heading line and <br> for a line break.',
	example: [
		'CmsMessage',
		{
			icon: '🚚',
			type: 'warning',
			text: '<strong>Verzögerte Lieferungen</strong><br>Wegen des Unwetters kann eine Lieferung nach Bayern derzeit einen Tag länger dauern.',
		},
	],
};
